import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  AiListeningBrandProfileApiService,
  DashboardParams,
} from 'src/services/aiListeningApi/brandProfile'

interface UseGetAiListeningProfileDashboardQueryParams extends DashboardParams {
  enabled?: boolean
  profileId?: string
}

// The range is part of the key: a new top-bar period is a new dashboard.
export const useGetAiListeningProfileDashboardQuery = ({
  enabled = true,
  from,
  profileId,
  subject,
  to,
}: UseGetAiListeningProfileDashboardQueryParams) => {
  return useQuery({
    enabled: enabled && !!profileId,
    placeholderData: keepPreviousData,
    queryFn: () =>
      AiListeningBrandProfileApiService.getDashboard(profileId ?? '', {
        from,
        subject,
        to,
      }),
    queryKey: [
      QueryKey.GET_AI_LISTENING_PROFILE_DASHBOARD,
      profileId,
      subject,
      from,
      to,
    ],
  })
}
